import { Component,ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams,ViewController,ModalController} from 'ionic-angular';
import { DbservicesProvider } from '../../providers/dbservices/dbservices';
import {ReservationdetailsPage} from '../../pages/reservationdetails/reservationdetails';
import {AvailabilityPage} from '../../pages/availability/availability';

@IonicPage()
@Component({
  selector: 'page-reservation',
  templateUrl: 'reservation.html',
})
export class ReservationPage {
  @ViewChild('content') content: any;
  openMenu = false;
  available;
  menuitem = [];
  menuitems = [];
  resturant;
  searchmenuitem = [];
  searchmenuitems = [];
  count: any;
  Total: any;
  items: any;
  Minimumorder: any;
  Maximumorder: any;
  queryText: any;
  checkoutlist: any;
  connection;
  messages = [];
  checkinglist:any=[];
  len:any;
  menu:any=[];
  cartid:any;
  menus:any=[];
  pageloaded;
  constructor(public viewCtrl: ViewController,public DBservice: DbservicesProvider,public navCtrl: NavController, public navParams: NavParams, public modalCtrl: ModalController) {
    this.Get_allcategory()
  }

  ionViewWillEnter() {
 
  }

   ionViewDidEnter() {
    setTimeout(() => {
      this.pageloaded = true;
    }, 2000);
  }

   ionViewDidLoad() {
    this.pageloaded = false;
  }

  Get_allcategory() {
    var data = {
      name: localStorage.restaurant
     
    }
    this.DBservice.get_all_category(data)
      .then(data => {
        console.log(data.message);
        // this.get_cart_item()
        if (data.message != undefined) {
          this.menu = data.message;
        for (var i = 0; i < this.menu.length; i++) {
          var k = i;
          for (var j = 0; j < this.menu[k].Items.length; j++) {
          
            if(this.menu[k].Items[j].current_availability){
            if(this.menu[k].Items[j].current_availability == 1)
            {
              this.menu[k].Items[j].availability = true
            }
            else{
              this.menu[k].Items[j].availability = false
            }
            }
            // data.message[k].searchproduct = data.message[k].Items[j].item
            // this.searchmenuitem.push(data.message[k].Items[j])
          }
          this.menuitem.push(this.menu[k])
          this.menuitems.push(this.menu[k])

          // this.searchmenuitem.push(data.message[k])
        
      }
      for (var i = 0; i < this.menuitem.length; i++) {
        var k = i;
        for (var j = 0; j < this.menuitem[k].Items.length; j++) {
          var v = j
          this.searchmenuitem.push(this.menuitem[k].Items[v]);
        }
      }
        }
        
        // this.menuitem = data.message;
      }, error => {
        console.log(JSON.stringify(error.json()));
      });
  }
  getItems() {
    if (this.queryText != undefined && this.queryText != null && this.queryText != "") {
      this.searchmenuitems = this.filterItems(this.queryText);
      this.menuitem = [];
    }
    else {
      this.menuitem = this.menuitems;
      this.searchmenuitems =[]
    }
  }

  filterItems(searchTerm) {
    return this.searchmenuitem.filter((item) => {
      return item.item.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1;
    });
  }




  update_availability(item){
    console.log(item)
    if(item.availability == true)
      this.available = 1
    else
      this.available = 0

      if(this.available == 1){
  
      var data={
        "product":item.name,
        "available": this.available,
        // "business":localStorage.restaurant,
        // "next_time":""
      }
      this.menus.push(data)
      // console.log(this.menus)
      this.update_menus(item)
      // this.menuitems = this.menuitem
    }
    else{
      this.itemSelected(item)
    }
  }
  
update_menus(item)
{
this.DBservice.update_availability(this.menus)
    // .map(res => res.json())
    .then(res => {
      console.log(res)
      if(res.message.status == 'Failed'){
        var d = JSON.parse(res._server_messages);
        var d1 = JSON.parse(d);
        this.DBservice.alert(d1.message)
      if(item.availability == true)
        item.availability = true;
      else
        item.availability = false;
      }
    }, error => {
      console.log(JSON.stringify(error.json()));
    });
    this.menus=[];
}
// doRefresh(refresher) {
    
//   this.Get_allcategory()

   
//     setTimeout(() => {
//       refresher.complete();
//     }, 200);
//   }

  Scrolllist(item) {
    this.openMenu = !this.openMenu;
    this.autoScroll(item.category);
  }
  autoScroll(category_name) {
    var itemList = document.getElementById(category_name).offsetTop;
    this.content.scrollTo(0, itemList, 500)
  }
  togglePopupMenu() {
    return this.openMenu = !this.openMenu;
  }
  itemSelected(value) {
    // console.log(title)
    let modal = this.modalCtrl.create(AvailabilityPage,{item:value});
    modal.present();
    modal.onDidDismiss(data => {
      if(data){
      console.log(data)


       var datas={
        "product":data.name,
        "available": 0,
        // "business":localStorage.restaurant,
        "next_time":data.times
      }
      this.menus.push(datas)
      this.update_menus(data)
    }
    else{
      value.current_availability = 1
      value.availability = true
    }
      
    // this.Get_allcategory()
    });
    
  }
  
}



// WEBPACK FOOTER //
// ./src/pages/reservation/reservation.ts